import React, { useEffect, useState } from 'react'
import './App.css';
import { Container, Grid, Button, Header, Loader, Dimmer, Form, Image } from 'semantic-ui-react'

import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";

import Web3Adapter from './Web3Adapter.js';

import Logo from './assets/logo.png';

const providerOptions = {
  walletconnect: {
    package: WalletConnectProvider,
    options: {
      infuraId: "c19ff672a85c4706a4a8471e2cefbb91"
    }
  }
};

function App() {

  const [isConnected, setConnection] = useState(false);
  const [web3Adapter, setWeb3Adapter] = useState(false);
  const [remaining, setRemaining] = useState(false)
  const [isLoading, setLoader] = useState(false)
  const [amount, setAmount] = useState(1)
  const [err, setErr] = useState("")

  useEffect(() => { }, [])

  const adapterCb = (event, data) => {
    console.log(event)
    switch (event) {
      case 'connected':
        if (!isConnected) {
          setConnection(true)
        }
        setError("")
        break;;
      case 'purchased':
        setRemaining(data)
        setError("")
        break;;
      case 'error':
        console.log(data)
        setError(data)
        break;;
      default:
        console.log(data)
    }
    setLoader(false);
  }

  const setError = (data) => {
    setErr(data)
  }

  const connect = async () => {
    try {
      if (isConnected) {
        return
      }
      const web3Modal = new Web3Modal({
        providerOptions,
      });
      let provider = await web3Modal.connect();
      if (!provider) {
        return;
      }

      let w3Adapter = new Web3Adapter(adapterCb)
      await w3Adapter.init(provider);
      let supply = await w3Adapter.remaining();
      setRemaining(supply)
      setWeb3Adapter(w3Adapter);
    }
    catch (ex) {
      console.log(ex)
    }
  }

  const notConnected = () => {
    return (
      <>
        <Container>
          <Grid.Row>
            <p>To purchase, please connect your wallet</p>
          </Grid.Row>
          <Grid.Row>
            <Button color="blue" onClick={() => connect()}>Connect Web3 Wallet</Button>
          </Grid.Row>
        </Container>
      </>
    )
  }

  const handleChange = (event) => {
    setAmount(event.target.value);
  }

  const purchase = async () => {

    try {
      if (isNaN(amount) || isNaN(parseInt(amount, 10)) || parseInt(amount, 10) > 5 || parseInt(amount, 10) < 0) {
        setError("Invalid amount")
        return
      }
      setLoader(true)
      await web3Adapter.purchase(amount);
    }
    catch (ex) {
      console.log(ex)
    }
  }
  const connected = () => {
    return (
      <>
        <Container textAlign="center">
          <Grid.Row textAlign="center" centered>
            <Form style={{ "alignItems": "center", "justifyContent": "center", "display": "flex" }} size="mini">
              <Form.Field style={{ "alignItems": "center", "width": "25%" }}>
                <p>Amount</p>
                <input placeholder="" value={amount} onChange={handleChange} />
              </Form.Field>
            </Form>
            <Button onClick={() => purchase()} color="blue">Purchase</Button>
          </Grid.Row>
          {err ?
            (
              < Grid.Row >
                <p className="error">{err ? err : ""}</p>
              </Grid.Row>
            )
            : (<></>)
          }
          <br></br>
          <Grid.Row>
            <p>Price: 0.05 ETH</p>
            <p>Max Per Tx: 5</p>
            <p>Remaining: {remaining || remaining == "0" ? remaining : "-"}/3333</p>
          </Grid.Row>
        </Container>
      </>
    )
  }


  return (
    <div className="App">
      <Container fluid>
        <Grid>
          <Dimmer className="overlay" active={isLoading}>
            <Loader className="overlay" active={isLoading} />
          </Dimmer>
          <Grid.Row centered>
            <Image src={Logo} size="huge" />
          </Grid.Row>
          <Grid.Row centered>
            {!isConnected ? notConnected() : connected()}
          </Grid.Row>
          <Grid.Row>
            <Container>
              <p>Crazy Cookie is an entirely on-chain generated NFT. All possible fortunes and backgrounds are deterministically generated and constructed in real time in the contract. You can even implement and use the SVG background contract to create your own fortune cookie NFT collection. </p>
            </Container>
          </Grid.Row>
        </Grid>
      </Container>
    </div>
  )

}

export default App;
